import { Section } from '../../sections/builders/section_builder';
import { ISectionsDatasource, ISectionsMeta } from '../../sections/datasources/sections_datasource';
import { IHash, IQuery, IQueryMediator } from 'core-ts-types';

export class AllSectionsQuery implements IQuery {
  private _result: Array<Section & ISectionsMeta>;

  constructor(QueryMediator: IQueryMediator, private ngSectionsDatasource: ISectionsDatasource) {
    QueryMediator.registerQuery(this, ngSectionsDatasource);
  }

  get result() {
    return this._result;
  }

  run() {
    this._result = this.ngSectionsDatasource.metasource().derived();
    return this;
  }
}
angular.module('capability-ng-scheduler').service('ngAllSectionsQuery', AllSectionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/queries/all_sections_query.ts